import { flatten } from 'lodash/fp'
import { createField, createSectionCreator } from 'e-submission/domain/data-model/form/utils'

export const EdaQrCodeSection = createSectionCreator((app, id, section) => {
  return flatten([
    createField(`EDA.qrCodePage`, [
      {
        id: `EDA.qrCodePage`,
        c: 'EdaQrCodePage',
      },
    ]),
  ])
})
